export default function BannerAd({ banner }) {
  if (!banner) return null;

  return (
    <div className="relative mx-auto my-4 w-full max-w-[1100px] overflow-hidden rounded-xl bg-slate-100 shadow-[0_6px_20px_rgba(0,0,0,0.06)] aspect-[1000/500]">
      <img
        src={banner.image}
        alt="Sponsored banner"
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover"
      />
      <a
        href={banner.buttonLink}
        target="_blank"
        rel="sponsored nofollow noopener noreferrer"
        className="absolute left-1/2 bottom-8 -translate-x-1/2 no-underline"
        aria-label={banner.buttonName}
      >
        <span className="inline-flex items-center rounded-md bg-sky-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm transition hover:bg-sky-700">
          {banner.buttonName}
        </span>
      </a>
    </div>
  );
}
